var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndividualMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 48,
    viewBox: "0 0 36 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1056 39.4472L2.89443 46.5528C1.56463 47.2177 0 46.2507 0 44.7639V2C0 0.895431 0.895432 0 2 0H34C35.1046 0 36 0.895432 36 2V44.7639C36 46.2507 34.4354 47.2177 33.1056 46.5528L18.8944 39.4472C18.3314 39.1657 17.6686 39.1657 17.1056 39.4472Z",
    fill: "#388AF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2572 19.0299C14.6842 18.9232 15.1308 19.1082 15.3573 19.4856C15.8952 20.3821 16.9104 20.8751 17.9998 20.8751C19.0891 20.8751 20.1044 20.3821 20.6423 19.4856C20.8687 19.1082 21.3153 18.9232 21.7423 19.0299C22.931 19.3271 24.1941 20.0444 25.2833 20.9975C26.3776 21.955 27.3586 23.2046 27.9283 24.6287C28.1334 25.1415 27.884 25.7234 27.3712 25.9286C26.8584 26.1337 26.2764 25.8843 26.0713 25.3715C25.6409 24.2956 24.872 23.2951 23.9663 22.5027C23.2773 21.8998 22.5448 21.4482 21.8777 21.1762C20.879 22.3272 19.4126 22.8751 17.9998 22.8751C16.587 22.8751 15.1205 22.3272 14.1218 21.1762C13.4547 21.4482 12.7222 21.8998 12.0333 22.5027C11.1276 23.2951 10.3586 24.2956 9.92825 25.3715C9.72314 25.8843 9.14117 26.1337 8.62839 25.9286C8.1156 25.7234 7.86619 25.1415 8.0713 24.6287C8.64094 23.2046 9.62196 21.955 10.7163 20.9975C11.8055 20.0444 13.0686 19.3271 14.2572 19.0299Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 11.8174C16.7946 11.8174 15.8174 12.7946 15.8174 14C15.8174 15.2054 16.7946 16.1826 18 16.1826C19.2054 16.1826 20.1826 15.2054 20.1826 14C20.1826 12.7946 19.2054 11.8174 18 11.8174ZM13.8174 14C13.8174 11.69 15.69 9.81738 18 9.81738C20.31 9.81738 22.1826 11.69 22.1826 14C22.1826 16.31 20.31 18.1826 18 18.1826C15.69 18.1826 13.8174 16.31 13.8174 14Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndividualMark);
export default __webpack_public_path__ + "static/media/IndividualMark.ee1dcbd5c21159a6eeba21bfbf8aa859.svg";
export { ForwardRef as ReactComponent };